module.exports = __webpack_public_path__ + "static/img/hainan-general-hospital.eb27f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hainan-general-hospital.png
// module id = +8ud
// module chunks = 1 2